export default {"src":"/_next/static/media/chevron-up.5ed8e3e8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};